var bookshelf = require("../index-extended");
require("./Resolution");

module.exports = bookshelf.model("Majority", {
  entityName: "Majority",
  entityTimestampable: true,
  entitySync: true,
  entityUuid: true,

  tableName: "majority",
  resolutions() {
    return this.hasMany("Resolution");
  },

  parse(res) {
    if (res.majority_conditions) res.majority_conditions = JSON.parse(res.majority_conditions);
    return res;
  },
  format(attrs) {
    if (attrs.majority_conditions)
      attrs.majority_conditions = JSON.stringify(attrs.majority_conditions);

    delete attrs["$id"];

    return attrs;
  },
});
